import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { format, startOfMonth, endOfMonth } from 'date-fns'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import { IClientsItem } from '../../../../../modules/API/Defaults/models/customers'
import { IQuotationTitle } from '../types/quotation'
import { Orders } from '../../../../../modules/API/Orders/orders'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import { LINKS } from '../../../../../Routs/config'
import { useNavigate } from 'react-router-dom'

const buildDateString = (): string => {
  const now = new Date()
  const from = format(startOfMonth(now), 'yyyyMMdd')
  const to = format(endOfMonth(now), 'yyyyMMdd')
  return `dateFrom=${from}&dateTo=${to}`
}

export const useOrderQuotationTitles = () => {
  const navigate = useNavigate()
  const customerList: IClientsItem[] = useSelector(
    (state: RootState) => state.defaults.clientList.list
  )

  const [customerID, setCustomerID] = useState<number>(0)
  const [searchInput, setSearchInput] = useState<string>('')
  const [date, setDate] = useState<Date>(new Date())
  const {
    data: titles,
    isLoading,
    setData: setTitles,
  } = useDataFetcher<IQuotationTitle[]>(
    Orders.getQuotationTitlesByDateRange,
    `DateFrom=${format(startOfMonth(date), 'yyyyMMdd')}&DateTo=${format(endOfMonth(date), 'yyyyMMdd')}`
  )

  const filteredTitles = useMemo(() => {
    if (!titles) return []
    return titles.filter((item) => {
      if (customerID !== 0 && item.customerId !== customerID) return false

      if (searchInput) {
        const query = searchInput.toLowerCase()
        const matchTitle = item.title?.toLowerCase().includes(query)
        const matchCustomer = item.customerDesc?.toLowerCase().includes(query)
        if (!matchTitle && !matchCustomer) return false
      }

      return true
    })
  }, [titles, customerID, searchInput])

  const handleChangeStatus = useCallback(
    async (titleID: number, status: number) => {
        console.log(titleID, status)
      if (!titles) return

      const prevTitles = [...titles]
      setTitles(
        titles.map((t) =>
          t.recId === titleID ? { ...t, status: status } : t
        )
      )

      try {
        await Orders.changeStatusQuotation(titleID, status)
        handleNotifications('הסטטוס עודכן', { type: 'success' })
      } catch {
        setTitles(prevTitles)
        handleNotifications('שגיאה בעדכון סטטוס', { type: 'error' })
      }
    },
    [titles, setTitles]
  )
  const handleDeleteQuotation = useCallback(
    async (titleID: number) => {
        if (!titles) return
        const prevTitles = [...titles]
        try {
            console.log(titleID)
            await Orders.deleteQuotation(titleID)
            setTitles(prevTitles.filter((t) => t.recId !== titleID))
            handleNotifications('הצעת מחיר נמחקה', { type: 'success' })
        } catch {
            setTitles(prevTitles)
            handleNotifications('שגיאה במחיקת הצעת מחיר', { type: 'error' })
        }
    },
    [titles, setTitles]
  )
  const handleNavigateToDetails = useCallback(
    (recId: number) => {
      navigate(`${LINKS.orders.quotation.details}/${recId}`)
    },
    [history]
  )

  const handleCreateNew = useCallback(() => {
    navigate(`${LINKS.orders.quotation.details}/new`)
  }, [history])
  return {
    filteredTitles,
    isLoading,
    searchInput,
    setSearchInput,
    customerID,
    setCustomerID,
    customerList,
    handleChangeStatus,
    handleNavigateToDetails,
    handleCreateNew,
    handleDeleteQuotation,
  }
}
